import type { CliConfigSchema } from '@macpaw/growthbook-next-cloudflare-pages-integration/types';

const config: CliConfigSchema = {
  variantsSourceDir: './pages/_ab-tests',
  generatedExperimentsOutputDir: './src/components/experiments',
  routerType: 'pages',
  wranglerConfigOutputDir: './',
  buildDir: './out',
  cfKvNamespace: 'KV_CLEARVPN_GB_PAYLOAD',
  gbApiHost: 'https://ft.macpaw.com',
  gbAppIdentity: 'cvpn-site',
  experiments: {
    'TBT-162': ['/', '/pricing', '/aff-buy', '/aff-trial', '/guest-upgrade'],
  },
};

export default config;
